import request from './request.js'
export function authLogin(data) {
	return request({
		url: '/acct_security/authMobile/weixin_mini',
		data: data,
		header: {
			'clientType': 'weixinmini',
			'Authorization': '',
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		method: 'POST', //必须大写
		isLoading: true, //是否显示加载框
		needToken: false, //是否需要token
		needDeviceId: true, //是否需要deviceId
	})
}
